import { memo } from 'react';
import { buildTimeFromServer } from '@src/forBack/buildTimeFromServer.ts';
import * as st from './styles.module.scss';

export const BuildTime = memo(() => (
  <span id="buildTimer" className={st.fixedTimer}>
    {buildTimeFromServer}
  </span>
));
